import { lazy, Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

const ExcelUniverDemoPage = lazy(
  () => import("@client/components/excel-univer-demo/excel-univer-demo-page"),
);

export const Route = createFileRoute("/excel-univer-demo")({
  component: ExcelUniverDemoRoute,
});

function ExcelUniverDemoRoute() {
  return (
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center gap-2 bg-background text-muted-foreground">
          <Loader2 className="size-5 animate-spin" aria-hidden="true" />
          <span>正在加载 Univer Excel 编辑器…</span>
        </div>
      }
    >
      <ExcelUniverDemoPage />
    </Suspense>
  );
}
